import Section from '../common/Section';
import { battingStyles, bowlingStyles, primaryRoles } from '../../constants/playerOptions';

const SkillSection = ({ data, onChange, onToggleSkill }) => {
  const isRoleLocked = false;
  const isPlayerRole = (role) => role.toLowerCase() === 'player';

  return (
    <Section eyebrow="Step 2" title="Player role & skills">
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Primary Role</label>
          <select
            name="primaryRole"
            className="form-select"
            value={data.primaryRole}
            onChange={(e) => onChange('skills', 'primaryRole', e.target.value)}
            required
            disabled={isRoleLocked}
          >
            <option value="">Select your core role</option>
            {primaryRoles.map((role) => (
              <option key={role} value={role} disabled={isPlayerRole(role)}>
                {role}
              </option>
            ))}
          </select>
          {isRoleLocked ? (
            <p className="text-muted small mb-0">Primary role is set to Player for registered users.</p>
          ) : (
            <p className="text-muted small mb-0">Player is locked, but you can add additional roles.</p>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">Batting Style</label>
          <select
            name="battingStyle"
            className="form-select"
            value={data.battingStyle}
            onChange={(e) => onChange('skills', 'battingStyle', e.target.value)}
          >
            <option value="">Select</option>
            {battingStyles.map((style) => (
              <option key={style} value={style}>
                {style}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">Bowling Style</label>
          <select
            name="bowlingStyle"
            className="form-select"
            value={data.bowlingStyle}
            onChange={(e) => onChange('skills', 'bowlingStyle', e.target.value)}
          >
            <option value="">Select</option>
            {bowlingStyles.map((style) => (
              <option key={style} value={style}>
                {style}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex flex-wrap gap-3 mt-3 fancy-checkbox-grid">
        {primaryRoles.map((role) => (
          <label key={role} className="fancy-checkbox" htmlFor={`skill-${role}`}>
            <input
              type="checkbox"
              className="fancy-checkbox-input"
              id={`skill-${role}`}
              checked={data.skillTags.includes(role)}
              onChange={() => onToggleSkill(role)}
              disabled={isRoleLocked || isPlayerRole(role)}
            />
            <span className="fancy-checkbox-box" aria-hidden="true" />
            <span className="fancy-checkbox-label">{role}</span>
          </label>
        ))}
      </div>
    </Section>
  );
};

export default SkillSection;
